import { RouteConfig } from 'vue-router'

import {
	RatesLunchIndex,
    PositionsIndex,
    CostCenterIndex,
    AreaIndex,
    SubAreaIndex,
    WorkShiftsIndex,
    AfpsIndex,
    OtherConfigIndex,
    MediumHeavyIndex,
    ReasonForPermissionIndex,
    HolidayIndex,
    DevicesIndex,
    WorkDescriptionsIndex,
    ReasonForTerminationWorkIndex,
    AdvanceTypesIndex,
    InsuranceCompanyIndex,
    DiscountTypeIndex,
    BondTypesIndex,
    ListUsers,
    SignaturesList
} from '@/views'

const configRouter: Array<RouteConfig> = [
	{
        path: 'rates-lunch',
        name: 'ratesLunch',
        component: RatesLunchIndex,
        meta: {
            requiresVisitor: false,
            requiresAuth: true,
            title: 'Tarifas de Refrigerio'
        }
    },
    {
        path: 'positions',
        name: 'positions',
        component: PositionsIndex,
        meta: {
            requiresVisitor: false,
            requiresAuth: true,
            title: 'Cargos'
        }
    },
    {
        path: 'cost-center',
        name: 'cost_center',
        component: CostCenterIndex,
        meta: {
            requiresVisitor: false,
            requiresAuth: true,
            title: 'Centro de Costos'
        }
    },
    {
        path: 'areas',
        name: 'areas',
        component: AreaIndex,
        meta: {
            requiresVisitor: false,
            requiresAuth: true,
            title: 'Areas'
        }
    },
    {
        path: 'sub-areas',
        name: 'subAreas',
        component: SubAreaIndex,
        meta: {
            requiresVisitor: false,
            requiresAuth: true,
            title: 'Sub-Areas'
        }
    },
    {
        path: 'insurance-companies',
        name: 'insurance-companies',
        component: InsuranceCompanyIndex,
        meta: {
            requiresVisitor: false,
            requiresAuth: true,
            title: 'Copañia de Seguros'
        }
    },
    {
        path: 'work-shifts',
        name: 'workShifts',
        component: WorkShiftsIndex,
        meta: {
            requiresVisitor: false,
            requiresAuth: true,
            title: 'Turnos de Trabajo'
        }
    },
    {
        path: 'afp',
        name: 'afps',
        component: AfpsIndex,
        meta: {
            requiresVisitor: false,
            requiresAuth: true,
            title: 'AFP'
        }
    },
    {
        path: 'heavy',
        name: 'heavy',
        component: MediumHeavyIndex,
        meta: {
            requiresVisitor: false,
            requiresAuth: true,
            title: 'Pesadas'
        }
    },
    {
        path: 'other-config/:id',
        name: 'otherConfig',
        component: OtherConfigIndex,
        meta: {
            requiresVisitor: false,
            requiresAuth: true,
            title: 'Otras Configuraciones'
        }
    },
    {
        path: 'reason-for-permission',
        name: 'reasonForPermission',
        component: ReasonForPermissionIndex,
        meta: {
            requiresVisitor: false,
            requiresAuth: true,
            title: 'Motivos de Permisos'
        }
    },
    {
        path: 'advance-types',
        name: 'advanceTypes',
        component: AdvanceTypesIndex,
        meta: {
            requiresVisitor: false,
            requiresAuth: true,
            title: 'Tipos de Adelantos'
        }
    },
    {
        path: 'bond-types',
        name: 'bond-types',
        component: BondTypesIndex,
        meta: {
            requiresVisitor: false,
            requiresAuth: true,
            title: 'Tipos de Bonos'
        }
    },
    {
        path: 'holiday',
        name: 'holiday',
        component: HolidayIndex,
        meta: {
            requiresVisitor: false,
            requiresAuth: true,
            title: 'Días Festivos'
        }
    },
    {
        path: 'devices',
        name: 'devices',
        component: DevicesIndex,
        meta: {
            requiresVisitor: false,
            requiresAuth: true,
            title: 'Dispositivos'
        }
    },
    {
        path: 'work-description',
        name: 'work-description',
        component: WorkDescriptionsIndex,
        meta: {
            requiresVisitor: false,
            requiresAuth: true,
            title: 'Descripción de Trabajos'
        }
    },
    {
        path: 'reason-for-terminarion-work',
        name: 'reason-for-terminarion-work',
        component: ReasonForTerminationWorkIndex,
        meta: {
            requiresVisitor: false,
            requiresAuth: true,
            title: 'Razon de Cese de Trabajos'
        }
    },
    {
        path: 'discount-types',
        name: 'discount-types',
        component: DiscountTypeIndex,
        meta: {
            requiresVisitor: false,
            requiresAuth: true,
            title: 'Tipos de Descuento'
        }
    },
    {
        path: 'users',
        name: 'users',
        component: ListUsers,
        meta: {
            requiresVisitor: false,
            requiresAuth: true,
            title: 'Usuarios'
        }
    },
    {
        path: 'signatures',
        name: 'signatures',
        component: SignaturesList,
        meta: {
            requiresVisitor: false,
            requiresAuth: true,
            title: 'Firmas'
        }
    }
]

export default configRouter
